import message from '@/components/message'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { $t } from '@/i18n'
import store from '@/store'
import {Message} from "element-ui";

const baseURL = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL

export default {
  namespaced: true,

  state: {
    socialReviews: {
      total: 0,
      list: [],
      pagination: {
        total: 0,
        page: 1,
        nb_page: 1,
        from: 0,
        to: 0,
        previous: 0,
        next: 0
      }
    },
    filters: {
      page: 1,
      limit: 20,
      search: '',
      beforeCreation: null,
      beforeDetection: null,
      afterDetection: null,
      afterCreation: null,
      type: null
    },
    loadingStatus: false,
    postToDelete: null,
    modalDelete: false,
    modalResponse: false,
    idReviewToAnswer: null,
    currentReview: null,
    textAnswer: null,
    loadingStatusModal: false,
    suggestedAnswer: null,
    loadingExportReviews: false,
    exportReviews: null
  },
  getters: {
    getSocialReviews: state => state.socialReviews,
    getPage: state => state.filters.page,
    getLimit: state => state.filters.limit,
    getLoadingStatus: state => state.loadingStatus,
    getLoadingStatusModal: state => state.loadingStatusModal,
    getPagination: state => state.socialPostsEditoriaux.pagination,
    getPostToDelete: state => state.postToDelete,
    getModalDelete: state => state.modalDelete,
    getModalResponse: state => state.modalResponse,
    getTotal: state => state.socialPostsEditoriaux.total,
    getIdReviewToAnswer: state => state.idReviewToAnswer,
    getCurrentReview: state => state.currentReview,
    getTextAnswer: state => state.textAnswer,
    getSuggestedAnswer: state => state.suggestedAnswer,
    getLoadingExportReviews: state => state.loadingExportReviews,
    getExportReviews: state => state.exportReviews
  },
  mutations: {
    setSocialReviews (state, payload) {
      state.socialReviews = payload
    },
    setReviewList (state, payload) {
      state.socialReviews.list = payload
    },
    setPage (state, payload) {
      state.filters.page = payload
    },
    setLimit (state, payload) {
      state.filters.limit = payload
    },
    setLoadingStatus (state, payload) {
      state.loadingStatus = payload
    },
    setLoadingStatusModal (state, payload) {
      state.loadingStatusModal = payload
    },
    setPagination (state, payload) {
      state.socialReviews.pagination = payload
    },
    setPostToDelete (state, payload) {
      state.postToDelete = payload
    },
    setModalDelete (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    setModalResponse (state, modalResponse) {
      state.modalResponse = modalResponse
    },
    setIdReviewToAnswer (state, idReviewToAnswer) {
      state.idReviewToAnswer = idReviewToAnswer
    },
    setCurrentReview (state, currentReview) {
      state.currentReview = currentReview
    },
    setTotal (state, total) {
      state.socialReviews.total = total
    },
    setTextAnswer (state, textAnswer) {
      state.textAnswer = textAnswer
    },
    setSuggestedAnswer (state, suggestedAnswer) {
      state.suggestedAnswer = suggestedAnswer
    },
    setLoadingExportReviews (state, bool) {
      state.loadingExportReviews = bool
    },
    setReviewsExport (state, exportReviews) {
      state.exportReviews = exportReviews
    }
  },

  actions: {
    loadSocialReviews ({ commit, getters }) {
      commit('setLoadingStatus', true)
      const url = `${baseURL}/reviews?page=${getters.getPage}`

      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then(response => {
          commit('setReviewList', response.data.reviews)
          commit('setPagination', response.data.pagination)
          commit('setTotal', response.data.pagination.total)
          commit('setLoadingStatus', false)
        })
        .catch(error => {
          commit('setLoadingStatus', false)
          return { type: 'error', message: error }
        })
        .finally(() => {
          commit('setLoadingStatus', false)
        })
    },

    replyToAReview (context, payload) {
      context.commit('setLoadingStatusModal', true)
      const params = {
        network: store.getters.getSitimmoUser.codeReseauSfc,
        comment: context.getters.getTextAnswer
      }
      const url = `${baseURL}/reviews/${context.getters.getCurrentReview.id}/answers`

      HTTP_HYPER_ESPACE_BACKEND.post(url, params)
        .then(response => {
          context.commit('setLoadingStatusModal', false)
          context.dispatch('loadSocialReviews')
          message.success($t('socialReviews.modal.messageModal'))
        })
        .catch(error => {
          context.commit('setLoadingStatusModal', false)
          message.error(`Erreur : ${error}`)
          return { type: 'error', message: error }
        })
        .finally(() => {
          context.commit('setLoadingStatusModal', false)
        })
    },

    generateTextIA (context) {
      context.commit('setLoadingStatusModal', true)
      const params = {
        network: store.getters.getSitimmoUser.codeReseauSfc,
      }
      const url = `${baseURL}/reviews/${context.getters.getCurrentReview.id}/answer_suggest`

      HTTP_HYPER_ESPACE_BACKEND.post(url, params)
        .then(response => {
          if (response.status === 200) {
            HTTP_HYPER_ESPACE_BACKEND.get(url)
              .then(response => {
                context.commit('setLoadingStatusModal', false)
                context.commit('setSuggestedAnswer', response.data)
                context.commit('setTextAnswer', response.data.suggestion)
              })
              .catch(error => {
                context.commit('setLoadingStatusModal', false)
                message.error(`Erreur : ${error}`)
                return { type: 'error', message: error }
              })
              .finally(() => {
                context.commit('setLoadingStatusModal', false)
              })
          }
        })
        .catch(error => {
          context.commit('setLoadingStatusModal', false)
          message.error(`Erreur : ${error}`)
          return { type: 'error', message: error }
        })
        .finally(() => {
          context.commit('setLoadingStatusModal', false)
        })
    },

    getSuggestedTextIA (context) {
      context.commit('setLoadingStatusModal', true)
      const url = `${baseURL}/reviews/${context.getters.getCurrentReview.id}/answer_suggest`

      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then(response => {
          context.commit('setLoadingStatusModal', false)
          context.commit('setSuggestedAnswer', response.data)
          context.commit('setTextAnswer', response.data.suggestion)
        })
        .catch(error => {
          context.commit('setLoadingStatusModal', false)
          message.error(`Erreur : ${error}`)
          return { type: 'error', message: error }
        })
        .finally(() => {
          context.commit('setLoadingStatusModal', false)
        })
    },
    exportReviews ({ commit }) {
      commit('setLoadingExportReviews', true)
      const url = `${baseURL}/export/reviews`
      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then((response) => {
          commit('setReviewsExport', response.data)
        })
        .catch(() => {
          Message.error('Error export')
        })
        .finally(() => {
          commit('setLoadingExportReviews', false)
        })
    }
  }
}
